var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "460px",
    height: "460px",
    viewBox: "0 0 460 460",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(25.882353%,52.156863%,95.686275%)",
      fillOpacity: 1
    },
    d: "M 455.113281 235.175781 C 455.113281 220.035156 453.769531 205.660156 451.472656 191.667969 L 234.886719 191.667969 L 234.886719 278.109375 L 358.894531 278.109375 C 353.335938 306.476562 337.046875 330.433594 312.894531 346.726562 L 312.894531 404.226562 L 386.878906 404.226562 C 430.195312 364.167969 455.113281 305.132812 455.113281 235.175781 Z M 455.113281 235.175781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20.392157%,65.882353%,32.54902%)",
      fillOpacity: 1
    },
    d: "M 234.886719 460 C 296.988281 460 348.929688 439.300781 386.878906 404.226562 L 312.894531 346.726562 C 292.195312 360.523438 265.9375 368.957031 234.886719 368.957031 C 174.894531 368.957031 124.105469 328.515625 105.894531 273.890625 L 29.613281 273.890625 L 29.613281 333.117188 C 67.371094 408.25 144.996094 460 234.886719 460 Z M 234.886719 460 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,73.72549%,1.960784%)",
      fillOpacity: 1
    },
    d: "M 105.894531 273.890625 C 101.105469 260.089844 98.613281 245.332031 98.613281 230 C 98.613281 214.667969 101.296875 199.910156 105.894531 186.109375 L 105.894531 126.882812 L 29.613281 126.882812 C -3.367188 191.671875 -3.367188 268.328125 29.613281 333.117188 Z M 105.894531 273.890625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(91.764706%,26.27451%,20.784314%)",
      fillOpacity: 1
    },
    d: "M 234.886719 91.042969 C 268.8125 91.042969 299.097656 102.734375 323.054688 125.542969 L 388.605469 59.992188 C 348.929688 22.808594 296.988281 0 234.886719 0 C 144.996094 0 67.371094 51.75 29.613281 126.882812 L 105.894531 186.109375 C 124.105469 131.484375 174.894531 91.042969 234.886719 91.042969 Z M 234.886719 91.042969 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.f69dfd5bd001deaecafc0f0a5dec4005.svg";
export { ForwardRef as ReactComponent };